var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemCascade = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M12 4a2.998 2.998 0 0 1 1 5.825V11h6a1 1 0 0 1 1 1v2.174A2.998 2.998 0 0 1 19 20a3 3 0 0 1-1-5.826V13h-5v1.174A2.998 2.998 0 0 1 12 20a3 3 0 0 1-1-5.826V13H6v1.174A2.998 2.998 0 0 1 5 20a3 3 0 0 1-1-5.826V12a1 1 0 0 1 1-1h6V9.825A2.998 2.998 0 0 1 12 4M5 16a1 1 0 1 0 0 2 1 1 0 0 0 0-2m7 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2m7 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2M12 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2",
  clipRule: "evenodd"
})));
export default SvgGemCascade;